<template>
    <div class="mconarall">
        <Header :header="header"></Header>
        <!--依照套用參數進入樣板-->
        <component :is="currentComponent" v-model="querylist"></component >
    </div>
</template>
<script>
import Header from '../../components/admin/NavBar/Header.vue';

export default{
    components:{
        Header
    },
    data(){
        return{
            //標頭
            header:{
                text1:"權限管理",
                text2:"帳號管理",
                text3:"群組管理",
            },
            //樣式名稱
            currentComponent:null,
            //頁面參數
            querylist:{
                id:"",

            },

            //API
            //帳號管理
            apiUserInfoType: (data) => this.userRequest.post("bicd/UserInfo", data),
        }
    },
    props:[],
    mounted(){
        this.querylist = this.$route.query;
        this.querylist.typeId = this.$route.query.PJID.substring(8,this.$route.query.PJID.length);
        if(!this.$route.query.lang){
            this.querylist.lang="1";
        }

        //初始化
        this.init();
    },
    watch:{
        "$route.query"(){
            this.querylist = this.$route.query;
            this.querylist.typeId = this.$route.query.PJID.substring(8,this.$route.query.PJID.length);
            if(!this.$route.query.lang){
                this.querylist.lang="1";
            }
            this.createView();
        }
    },
    methods:{
        //初始化
        init(){
        },
        //切換內容畫面
        async createView(){
            //取得網址的樣式名稱，並進行動態轉換，以減少讀取時間
            switch(this.$route.query.modal){
                //單一頁面
                case "1":
                    //切換樣式，並匯入必要參數
                    break;
                //列表頁面
                case "2":
                    //切換樣式，並匯入必要參數
                     this.currentComponent = (await import('../../components/admin/Content/AccountGroup/List.vue')).default;
                    break;
                //內容頁面
                case "3":
                    //切換樣式，並匯入必要參數
                    this.currentComponent = (await import('../../components/admin/Content/AccountGroup/Content.vue')).default;
                    break;
                //從資料庫取得樣式
                case undefined:
                    //TODO 動態讀取頁面功能
                    break;
            }
        }

    },
    async created(){
        this.createView();
    }
}
</script>